import { createSlice } from "@reduxjs/toolkit";
import { loginUser } from "../thunk/loginUser";
import { registerUser } from "../thunk/registerUser";
import { clearItem, saveStorage } from "../../Utils/Utils";
import { fetchOrders, updateOrderStatus } from "../thunk/checkout";
import { getAllUsers, toggleUserStatus } from "../thunk/adminUser";



const userSlice = createSlice({
  name: 'user',
  initialState: {
    isLoading: false,
    data: null,
    error: null,
    myOrders: [],
    token: '',
    allUsers: [],
    allOrders: [],
  },
  reducers: {},
  extraReducers(builder) {
    builder.addCase(loginUser.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(loginUser.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      saveStorage("user", action.payload);
    });
    builder.addCase(loginUser.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error;
    });
    builder.addCase(registerUser.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      saveStorage("user", action.payload);
    });
    builder.addCase(getAllUsers.fulfilled, (state, action) => {
      state.isLoading = false;
      state.allUsers = action.payload;
    });
    builder.addCase(toggleUserStatus.fulfilled, (state, action) => {
      if (!action.payload) return;
      const { userId, isActive } = action.payload;
      const user = state.allUsers.find(u => u.id === userId);
      if (user) user.isActive = isActive;
    });
    builder.addCase("user/logout", (state, action) => {
      state.data = null;
      state.allUsers = [];
      state.allOrders = [];
      state.myOrders = [];
      clearItem("user");
      clearItem("token");
    });
    builder.addCase(fetchOrders.fulfilled, (state, action) => {
      if (action?.meta?.arg?.isAdmin) {
        state.allOrders = action.payload;
      }
      else {
        state.myOrders = action.payload;
      }
      state.isLoading = false;
    });
    builder.addCase(updateOrderStatus.fulfilled, (state, action) => {
      if (!action.payload) return;
      const { orderId, status } = action.payload;
      const order = state.allOrders.find(o => o.id === orderId);
      if (order) order.orderStatus = status;
    });
  }
});

export const userReducer = userSlice.reducer;
